import { AcceptIcon, Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

export default function ActualStep({ ListStatus, status }) {
    const stepper = ListStatus.find(
        (item) => item?.status_name === status || item?.status_text === status
    );
    return (
        <Flex gap="gap.large">
            {ListStatus?.map((statusItem) => {
                const highlight = statusItem?.id == stepper?.id;

                return (
                    <BadgeStatus key={statusItem?.id} column>
                        {stepper?.id > statusItem?.id && (
                            <StatusNumber
                                color={"#616161"}
                                content={
                                    <AcceptIcon styles={{ color: "#616161" }} />
                                }
                            />
                        )}
                        {stepper?.id < statusItem?.id && (
                            <StatusNumber
                                color={"#C7C7C7"}
                                content={statusItem?.id}
                            />
                        )}
                        {stepper?.id === statusItem?.id && (
                            <StatusNumber
                                bgColor={"#5B5FC7"}
                                color={"#fff"}
                                content={statusItem?.id}
                            />
                        )}

                        {stepper?.id > statusItem?.id && (
                            <StepDone content={statusItem?.name} />
                        )}
                        {stepper?.id == statusItem?.id && (
                            <CurrentStep content={statusItem?.name} />
                        )}
                        {stepper?.id < statusItem?.id && (
                            <NextStep content={statusItem?.name} />
                        )}
                    </BadgeStatus>
                );
            })}
        </Flex>
    );
}

export const NextStep = styled(Text)`
    color: #c7c7c7;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;
export const CurrentStep = styled(Text)`
    color: #5b5fc7;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;
export const StepDone = styled(Text)`
    color: #616161;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

export const StatusNumber = styled(Text)`
    /* color: ${({ highlight }) => (!highlight ? "#C7C7C7" : "#fff")}; */
    color: ${({ color }) => color};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    border-radius: 40px;
    /* background-color: ${({ highlight }) =>
        highlight ? "#5b5fc7" : "#ffffff"}; */
    background-color: ${({ bgColor }) => bgColor};
    width: 28px;
    height: 28px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    outline: 2px solid ${({ color }) => color};
`;

export const BadgeStatus = styled(Flex)`
    width: 120px;
    height: 54px;
    justify-content: center;
    align-items: center;
    gap: 4px;
`;
